module.exports = __webpack_public_path__ + "media/images/message-templates-empty-051609573b4ec9b4fee9f73bda720018.svg";